module.exports = __webpack_public_path__ + "img/expediente_cientifico_glifosato_movil.62fef9b1.png";